import React from 'react';
import Typography from '@material-ui/core/Typography';

import Base from './Base';


function IcingGameEvent({event, periods}) {
  const period = periods[event.period].name;

  return (
    <Base
      time={event.second}
      period={period}
      type="Offside"
    >
      <Typography variant="body2">
        The play has been whistled dead due to a player being offside.
      </Typography>
    </Base>
  )
}

export default IcingGameEvent;
